export enum AlignmentType {
	Left = 0,
	Center = 1,
	Right = 2
}